import { all, call } from 'redux-saga/effects'

import { runAuthSagas } from './auth'
import { runBraintreeSagas } from './braintree'
import { runFormDataSagas } from './formData'
import { runFormSettingsSagas } from './formSettings'
import { runLandingPageSagas } from './landingPage'
import { runPaymentSagas } from './payment'
import { runPromoCodeSagas } from './promocode'
import { runStripeSagas } from './stripe'
import { runTeamsSagas } from './teams'
import { runVoucherSagas } from './voucher'

export default function* root() {
  yield all([
    call(runFormSettingsSagas),
    call(runFormDataSagas),
    call(runAuthSagas),
    call(runPaymentSagas),
    call(runLandingPageSagas),
    call(runBraintreeSagas),
    call(runVoucherSagas),
    call(runPromoCodeSagas),
    call(runTeamsSagas),
    call(runStripeSagas),
  ])
}
